import { gql } from "@apollo/client";

export const MOMENT_CREATE_MONTAGE = gql`
  mutation MomentCreateClip(
    $MomentsCreateMontageInput: MomentsCreateMontageInput!
  ) {
    momentsCreateMontage(
      MomentsCreateMontageInput: $MomentsCreateMontageInput
    ) {
      errors {
        field
        code
        message
      }
      success
      moments {
        id
      }
      trackId
    }
  }
`;
